import React from 'react'

const Shop: React.FC = () => {
  return (
    <div>
      Shop
    </div>
  )
}

export default Shop
